import React from 'react';
import styled from 'styled-components';
import { MQ_FOR_TABLET_LANDSCAPE_UP } from 'web-ui-kit/media';
import { Header5LargeStyles, BodySmallStyles, BodyLargeStyles } from 'web-ui-kit/typography';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3;
/**
 * Displays a simple list of items with heading.
 */


function ListParagraph(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? '' : _ref$id,
      _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? '' : _ref$heading,
      _ref$list = _ref.list,
      list = _ref$list === void 0 ? [] : _ref$list;
  var Container = styles.Container,
      Detail = styles.Detail,
      Heading = styles.Heading;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      "data-testid": id
    },
    /*#__PURE__*/
    React.createElement(Heading, null, heading), list.map(function (detail, index) {
      return (
        /*#__PURE__*/
        React.createElement(Detail, {
          key: index
        }, detail)
      );
    }))
  );
}

var styles = {
  Container: styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 1.25rem;\n  "]))),
  Heading: styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.25rem;\n  "])), Header5LargeStyles),
  Detail: styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n    margin-bottom: 0.25rem;\n\n    ", " {\n      ", ";\n      margin-bottom: 0.25rem;\n    }\n  "])), BodySmallStyles, MQ_FOR_TABLET_LANDSCAPE_UP, BodyLargeStyles)
};
export default ListParagraph;